import { render } from "./ProductDesView.vue?vue&type=template&id=0993c226"
import script from "./ProductDesView.vue?vue&type=script&lang=js"
export * from "./ProductDesView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__